function isPlainObject(value) {
    return (value !== null &&
        typeof value === 'object' &&
        Array.isArray(value) === false);
}
export function applyTransform(parent, dataKey, transformerName, transformer, transformField, index) {
    const transformLevel = transformField[index];
    switch (transformLevel[0]) {
        case 'this': {
            if (!isPlainObject(parent) && !Array.isArray(parent)) {
                return;
            }
            // eslint-disable-next-line no-prototype-builtins
            if (parent.hasOwnProperty(dataKey)) {
                parent[dataKey] = transformer(parent[dataKey]);
            }
            break;
        }
        case 'access':
            if (!isPlainObject(parent[dataKey])) {
                return;
            }
            applyTransform(parent[dataKey], transformLevel[1], transformerName, transformer, transformField, index + 1);
            break;
        case 'select':
            for (const subTransformField of transformLevel[1]) {
                applyTransform(parent, dataKey, transformerName, transformer, subTransformField, 0);
            }
            break;
        case 'loop': {
            if (!Array.isArray(parent[dataKey])) {
                return;
            }
            const cast = parent[dataKey];
            for (let i = 0; i < cast.length; i += 1) {
                applyTransform(cast, i, transformerName, transformer, transformField, index + 1);
            }
            break;
        }
        case 'entries': {
            if (!parent[dataKey] ||
                typeof parent[dataKey] !== 'object' ||
                Array.isArray(parent[dataKey])) {
                return;
            }
            const cast = parent[dataKey];
            for (const key of Object.keys(cast)) {
                applyTransform(cast, key, transformerName, transformer, transformField, index + 1);
            }
            break;
        }
        case 'ref': {
            for (const subTransformField of transformLevel[1]()) {
                applyTransform(parent, dataKey, transformerName, transformer, subTransformField, 0);
            }
            break;
        }
    }
}
